import React, {useState, useEffect} from 'react'
import SegmentEditForm from './SegmentEditForm.js'
import ImageUpload from './ImageUpload.js'
import config from '../../config.js'
import _ from 'lodash'
import Axios from 'axios'
import qs from 'qs'

import './Editor.scss';


const Editor = props => {

    const loadJSON = (url, callback) => {
        //basic ajax get, sends data obj to callback on success
        return Axios.get(url + '?t=' + Date.now()).then(res => {
            if (res.status === 200) {
                console.log(url + ' loaded:', res.data)
                return callback(res.data);
            } else {
                console.log(url + ' load error:', res);
            }
        })
    }


    //force https -- doesn't work make work TODO
    // if(config.isAllenEnvironment){
    //     const location = window.location;
    //     if(window.location.protocol !== 'https:') {
    //         console.log('EDITOR: HTTPS redir')
    //         location.href = location.href.replace("http://", "https://");
    //     }
    // }

    const cl = props.currentLocation;

    const [lessonJSON, setLessonJSON] = useState(undefined);
    const [saving, setSaving] = useState({message:'Save'});
    const [message, setMessage] = useState('');
    const [name, setName] = useState('user');

    let serverSegmentData, clientSegmentData = undefined;
    if(cl.chapter >= 0){
        serverSegmentData = lessonJSON ? lessonJSON.chapters[cl.chapter].segments[cl.segment] : undefined; //whats in the actual json
        clientSegmentData = props.contentData.modules[cl.module].lessons[cl.lesson].chapters[cl.chapter].segments[cl.segment]; //what data is in state memory 
    }else{
        serverSegmentData = lessonJSON;
        clientSegmentData = props.contentData.modules[cl.module].lessons[cl.lesson];
    }
    useEffect(()=>{
        //whenever lesson url changes, reload the json files
        //should also trigger after a successful save to double check nothing is fucked
        if(!props.lessonURL) return console.log('EDITOR: invalid lesson url:', props.lessonURL);
        else {console.log(' url found!')}
        
        loadJSON(props.lessonURL, data =>{
            setLessonJSON(data)
        })
    }, [props.lessonURL])


    const commitChanges = (data) => {
        console.log('EDITOR: committing segment data with: ', data);
        updateServerData(data)
    }

    const onFormChange = (data) => {
        console.log('EDITOR: updating segment data with: ', data);
        updateClientData(data)
    }

    const updateServerData = (data) => {
        if(!props.config) return console.log('EDITOR: no config provided');
        if(!lessonJSON) return console.log('EDITOR: no lesson JSON loaded');
        if(!serverSegmentData) return console.log('EDITOR: no serverSegmentData');
        if(!clientSegmentData) return console.log('EDITOR: no clientSegmentData');
        if(!cl) return console.log('EDITOR: no currentLocation');
        if(window.location.protocol !== 'https:') return console.log('EDITOR: error need https');

        if(props.config.isLocalHost){
            //dev version
            console.log('EDITOR: dev env write', props.lessonURL);
            //node code
        }
        else if(props.config.isAllenEnvironment){
            console.log('EDITOR: allen env write', props.lessonURL);
            //allen server version

            //this code is for the shitty php app. when we migrate to a node app this code can live in the course probably

            //ajax to clients.alleni.com api
            let newData = _.cloneDeep(lessonJSON);
            if(cl.chapter >= 0){
                newData.chapters[cl.chapter].segments[cl.segment] = clientSegmentData;
            }else{
                newData = clientSegmentData;
            }
            ajaxToAllen(`${name} - ${message}`, newData, props.lessonURL);

        }
    }

    const ajaxToAllen = (message = 'no message', data = undefined, url = undefined) => {
        const commitMessage = (message);// do validation here
        if (config.repoURL && url && data) {
            setSaving({
                message: "Saving..."
            });

            const parseParentGuid = () => {
                return window.parent.location.href.split('/').slice(-1)[0];
            }

            const postBody = {
                projectID: parseParentGuid(),
                path: url,
                data: JSON.stringify(data, null, 2),
                message: `CMS Editor - ${commitMessage}`,
                repoURL: 'https://api.bitbucket.org/2.0/repositories/Allen_Interactions/' + config.repoURL,
            }

            console.log('EDITOR API: POSTING', postBody);

            Axios.post('https://clients.alleni.com/Api/content',
                qs.stringify(postBody),
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then((res) => {
                    console.log('EDITOR API: res', res)
                    setSaving({
                        message: "Saved!"
                    })
                    setMessage('')
                    setLessonJSON(data)
                }).catch((err) => {
                    console.log('EDITOR API: SAVE ERROR ', err);
                    setSaving({
                        message: "Error"
                    })
                })
        }
    }

    const updateClientData = (data) => {
        //updates state only doesn't write to files

        let temp = _.cloneDeep(props.contentData);
        if(cl.chapter >= 0){
            temp.modules[cl.module].lessons[cl.lesson].chapters[cl.chapter].segments[cl.segment] = data;
        }else{
            temp.modules[cl.module].lessons[cl.lesson] = data;
        }
        props.setContentData(temp)
    }

    useEffect(()=>{
        if(saving.message === "Saved!"){
            setTimeout(()=>{
                setSaving({
                    message: "Save"
                })
            }, 4000)
        }
    }, [saving])
    


    return (
        <div className={`Editor`}>
           
            {/* <ImageUpload config={config}/> */}


            <div className="message">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <label htmlFor="editor-name">Editor User Name:</label>
                            </td>
                            <td>
                                <input id={'editor-name'} type="text" value={name} placeholder={'Name'} onChange={(e)=>{setName(e.currentTarget.value)}}/>
                            </td>
                        </tr>
                        
                        <tr>
                            <td>
                                <label htmlFor="editor-message">Commit Message:</label>
                            </td>
                            <td>
                                <textarea id={'editor-message'} type="text" value={message} placeholder={'Message'} onChange={(e)=>{setMessage(e.currentTarget.value)}}/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        
            <SegmentEditForm 
                key={`${cl.module} ${cl.lesson} ${cl.chapter} ${cl.segment} -  editform`}
                onChange={onFormChange}
                commitChanges={commitChanges}
                saving={saving}
                data={clientSegmentData}
            />


            {/* <hr/>
            {props.lessonURL}
            <hr/>
            SERVER:
            <pre>{JSON.stringify(serverSegmentData, 0, 2)}</pre>
            <hr/>
            CLIENT:
            <pre>{JSON.stringify(clientSegmentData, 0, 2)}</pre>
            <hr/> */}
        </div>
    )
}

export default Editor